"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
var style_utilities_1 = require("@fluentui/style-utilities");
var utilities_1 = require("@fluentui/utilities");
var GlobalClassNames = {
    root: 'ms-WeeklyDayPicker-root',
};
var styles = function (props) {
    var _a;
    var className = props.className, theme = props.theme;
    var palette = theme.palette;
    var classNames = (0, style_utilities_1.getGlobalClassNames)(GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            style_utilities_1.normalize,
            {
                width: 220,
                padding: 12,
                boxSizing: 'content-box',
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
            },
            className,
        ],
        dayButton: {
            borderRadius: '100%',
        },
        dayIsToday: {},
        dayCell: {
            borderRadius: '100%!important',
        },
        daySelected: {},
        navigationIconButton: [
            (0, style_utilities_1.getFocusStyle)(theme, { inset: 0 }),
            {
                width: 12,
                minWidth: 12,
                height: 0,
                overflow: 'hidden',
                padding: 0,
                margin: 0,
                border: 'none',
                display: 'flex',
                alignItems: 'center',
                backgroundColor: palette.neutralLighter,
                fontSize: style_utilities_1.FontSizes.small,
                fontFamily: 'inherit',
                selectors: (_a = {},
                    _a[".".concat(classNames.root, ":hover &, .").concat(utilities_1.IsFocusVisibleClassName, " .").concat(classNames.root, ":focus &, ") +
                        ".".concat(utilities_1.IsFocusVisibleClassName, " &:focus")] = {
                        height: 53,
                        minHeight: 12,
                        overflow: 'initial',
                    },
                    _a[".".concat(utilities_1.IsFocusVisibleClassName, " .").concat(classNames.root, ":focus-within &")] = {
                        // edge does not recognize focus-within, so separate it out
                        height: 53,
                        minHeight: 12,
                        overflow: 'initial',
                    },
                    _a['&:hover'] = {
                        cursor: 'pointer',
                        backgroundColor: palette.neutralLight,
                    },
                    _a['&:active'] = {
                        backgroundColor: palette.neutralTertiary,
                    },
                    _a),
            },
        ],
        disabledStyle: {
            selectors: {
                '&, &:disabled, & button': {
                    color: palette.neutralTertiaryAlt,
                    pointerEvents: 'none',
                },
            },
        },
    };
};
exports.styles = styles;
//# sourceMappingURL=WeeklyDayPicker.styles.js.map